import {IBackDoorInfo} from 'modules/reducers/backdoor';
import {createAction} from 'redux-act';


export const fetchBackDoorInfo = createAction('fetchBackDoorInfo');
export const fetchBackDoorInfoSuccess = createAction<IBackDoorInfo>('fetchBackDoorInfoSuccess');
export const fetchBackDoorInfoFailed = createAction('fetchBackDoorInfoFailed');
